
import React from "react";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style/PestControlSection.css";
import HeroSlider from "./HeroSlider";
import { FaArrowRight } from "react-icons/fa";
import TestimonialSection from "./TestimonialSection";
import FAQSection from "./FAQSection";
const services = [
  {
    title: "Termite Control",
    description:
      "Termites are wood-destroying insects that can cause extensive damage to homes and structures. They feed on cellulose, weakening wood and compromising...",
    icon: "/assets/termite.webp",
  },
  {
    title: "Cockroach Control",
    description:
      "Eradicate cockroaches with our expert control services. Say goodbye to these resilient pests and enjoy a pest-free, hygienic environment.",
    icon: "/assets/cockroach.webp",
  },
  {
    title: "Bed Bugs Control",
    description:
      "Eliminate bed bugs with our expert control services. Sleep soundly knowing we've eradicated these troublesome pests from your home.",
    icon: "/assets/bedbug.webp",
  },
  {
    title: "Rodent Control",
    description:
      "Rodents can damage property and spread disease. Our control service ensures your space is free from mice and rats.",
    icon: "/assets/rodent.webp",
  },
  {
    title: "Wood Borer",
    description:
      "Protect your wooden furniture and structures from destructive wood borers with our professional pest control.",
    icon: "/assets/woodborer.webp",
  },
  {
    title: "Ant Control",
    description:
      "Stop ant invasions at the source. Our expert team ensures long-lasting relief from ants at your premises.",
    icon: "/assets/ant.webp",
  },
  {
    title: "General Pest Control",
    description:
      "Our general pest control tackles a wide range of pests, keeping your home or business clean and pest-free.",
    icon: "/assets/general pest.webp",
  },
  {
    title: "Dog Ticks",
    description:
      "Keep your pets and home safe from tick infestations with our effective dog tick treatment and prevention.",
    icon: "/assets/dog ticks.webp",
  },
];

export default function PestControlSection() {


  return (
    <>
      <HeroSlider />
      <div className="bg-dark ">
        <div className="container py-5">
          <div className="row g-4 justify-content-center">
            {services.map((service, index) => (
              <div className="col-md-6 col-lg-3" key={index}>
                <div className="card h-100 text-start">
                  <div className="card-body">
                    <img
                      src={service.icon}
                      alt={service.title}
                      className="mb-3"
                      style={{
                        width: "64px",
                        height: "64px",
                        objectFit: "contain",
                      }}
                    />
                    <h5 className="card-title fw-bold">{service.title}</h5>
                    <p className="card-text">{service.description}</p>
                    <a
                      href="#enquiry"
                      className="btn btn-orange d-flex align-items-center gap-2 mt-3"
                    >
                      Send Enquiry <FaArrowRight />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <TestimonialSection/>
      <FAQSection />
    </>
  );
}
